module.exports = __webpack_public_path__ + "images/icon_bet_minus_82981d6686e5a4b6fd9ad1abd4d50a11.svg";